import React from 'react'
import PropTypes from 'prop-types'
import Dialog from 'components/dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogActions from '@material-ui/core/DialogActions'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import FileDownloadOutlinedIcon from 'components/material-symbol/icons/FileDownload'
import { useDialogTitleStyles } from 'components/dialog/use-dialog-title-styles'

const DownloadPlanDialog = ({
  open,
  onClose,
  title,
  description,
  onDownload,
}) => {
  const classes = useDialogTitleStyles()

  const handleDownload = closeDialog => {
    onDownload()
    closeDialog()
  }

  return (
    <Dialog
      isOpen={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      showCloseButton
      classes={{ paper: classes.dialogPaper }}
    >
      {({ closeDialog }) => (
        <>
          <DialogTitle disableTypography classes={{ root: classes.titleRoot }}>
            <Typography component="h2" className={classes.title}>
              {title}
            </Typography>
            <Typography className={classes.bodyText}>{description}</Typography>
          </DialogTitle>
          <DialogActions className={classes.actions}>
            <Button onClick={closeDialog} color="primary">
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              startIcon={<FileDownloadOutlinedIcon />}
              onClick={() => handleDownload(closeDialog)}
            >
              Download
            </Button>
          </DialogActions>
        </>
      )}
    </Dialog>
  )
}

DownloadPlanDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  onDownload: PropTypes.func.isRequired,
}

export default DownloadPlanDialog
